import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.replace";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/base16-dark.css';
import 'codemirror/theme/duotone-light.css';
import 'codemirror/mode/javascript/javascript.js';
import ApiService from '../../../../services/apiService';
import LambdaApiService from '../../../../services/apiService/lambda';
import { mapState } from 'vuex';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
export default {
  name: 'CoreDtwinRuleEditConditionsWrapper',
  components: {
    codemirror: codemirror
  },
  props: {
    rule: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    // the states that are to be displayed / edited
    states: {
      type: Array,
      required: true
    },
    templateContext: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      conditionsTab: null,
      conditionSwitchPrompt: false,
      cmLineNumbers: false,
      scriptSyntaxError: 0
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    cmOptions: function cmOptions() {
      return {
        tabSize: 4,
        mode: {
          name: 'javascript',
          json: true
        },
        firstLineNumber: 0,
        theme: this.$store.state.app.UiTheme ? 'base16-dark' : 'duotone-light',
        lineNumbers: this.cmLineNumbers,
        line: true,
        foldGutter: true,
        styleActiveLine: true,
        styleSelectedText: true,
        hintOptions: {
          completeSingle: false
        },
        lineWrapping: false
      };
    },
    requiredRule: function requiredRule() {
      var _this = this;

      return [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }];
    },
    currentConditionType: function currentConditionType() {
      return this.rule.properties.conditionType;
    },
    otherConditionType: function otherConditionType() {
      return this.currentConditionType === 'script' ? 'tree' : 'script';
    },
    conditionSwitchPromptText: function conditionSwitchPromptText() {
      var firstType = this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler')["conditions".concat(this.otherConditionType.charAt(0).toUpperCase() + this.otherConditionType.slice(1))];
      var secondType = this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler')["conditions".concat(this.currentConditionType.charAt(0).toUpperCase() + this.currentConditionType.slice(1))]; // at the point when the prompt is displayed, the conditionTab-value has already been switched
      // thus, the "current" value is actually already in `otherConditionType`

      return this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.conditionSwitchPromptText', {
        firstType: firstType,
        secondType: secondType
      });
    },
    firstStateMetric: function firstStateMetric() {
      return (get(this.rule, 'properties.stateMetrics[0]') || {}).key;
    },
    metricsPreview: function metricsPreview() {
      return "function (".concat((get(this.rule, 'properties.stateMetrics') || []).map(function (m) {
        return m.key;
      }).join(', '), ") {");
    },
    stateMetrics: function stateMetrics() {
      return get(this.rule, 'properties.stateMetrics') || [];
    }
  }),
  watch: {
    conditionsTab: function conditionsTab() {
      var newType = this.conditionsTab.replace('tab-', '');

      if (newType !== this.currentConditionType) {
        this.rule.properties.conditionType = newType; // required to clone, so `currentConditionTag`-prop gets refreshed
        // it does not notice "deep" changes otherwise

        this.rule.properties = cloneDeep(this.rule.properties);

        if (this.rule.properties.conditionType === 'script') {
          this.refreshForm();
          this.roughEvaluateConditionScript();
        }
      }
    },
    rule: function rule() {
      this.cmLineNumbers = false;
      this.setConditionsTab();
    },
    'rule.properties.conditionScript': function rulePropertiesConditionScript() {
      this.roughEvaluateConditionScript();
    }
  },
  mounted: function mounted() {
    this.setConditionsTab();
  },
  methods: {
    convertToJavascript: debounce(function () {
      var _this2 = this;

      ApiService.digitalTwinRuleConvertConditions(this, {
        conditions: this.rule.properties.conditions
      }).then(function (data) {
        _this2.rule.properties.conditionScript = "return ".concat(data);
      }).catch(function (error) {
        console.error(error);
      });
    }, 500),
    roughEvaluateConditionScript: function roughEvaluateConditionScript() {
      var script = this.rule.properties.conditionScript || '';

      if (script.trim() === '' || /(\W?)return(\W)/gi.exec(script) === null) {
        this.scriptSyntaxError = this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.conditionScriptResultNotEmpty');
      } else {
        this.scriptSyntaxError = 0;
      }
    },
    evaluateConditionScript: function evaluateConditionScript() {
      var _this3 = this;

      var scriptToEval = "module.exports = ".concat(this.metricsPreview, "\n        ").concat(this.rule.properties.conditionScript, "\n      }");
      return LambdaApiService.evaluateScript({
        script: scriptToEval,
        scriptParams: get(this.rule, 'properties.stateMetrics', []).map(function () {
          return 42;
        })
      }).then(function (res) {
        _this3.scriptSyntaxError = get(res, 'error');
      }).catch(function (error) {
        console.error(error);
      });
    },
    setConditionsTab: function setConditionsTab() {
      var type = get(this.rule, 'properties.conditionType');

      if (type) {
        this.conditionsTab = "tab-".concat(type);
      } else {
        this.conditionsTab = Object.keys(get(this.rule, 'properties.conditions', {})).length > 0 ? 'tab-tree' : 'tab-script';
      }

      this.rule.properties.conditionType = this.conditionsTab.replace('tab-', '');
    },
    refreshForm: function refreshForm() {
      var _this4 = this;

      setTimeout(function () {
        // required workaround to get the cursor appearing at the right spot
        // https://discuss.codemirror.net/t/codemirror-cursor-is-not-partially-visible/648/6
        _this4.$refs.codemirror.codemirror.refresh();

        _this4.$refs.codemirror.codemirror.focus();
      }, 50);
    },
    onCmFocus: function onCmFocus() {
      this.refreshForm();
      this.cmLineNumbers = true;
    }
  }
};